"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetSelectionParamsFull = exports.SetSelectionParams = exports.SetSelectionParamsBase = void 0;
var tslib_1 = require("tslib");
var fixed_1 = require("@devexpress/utils/lib/intervals/fixed");
var SetSelectionParamsBase = (function () {
    function SetSelectionParamsBase() {
        this.endOfLine = true;
        this.keepX = -1;
        this.correctIntervalDueToFields = true;
        this.correctIntervalDueToTables = true;
        this.useFieldUiChecks = true;
    }
    SetSelectionParamsBase.prototype.setInterval = function (interval) {
        this._intervals = [interval.clone()];
        return this;
    };
    SetSelectionParamsBase.prototype.resetKeepX = function () {
        this.keepX = -1;
        return this;
    };
    SetSelectionParamsBase.prototype.setPosition = function (position) {
        this._intervals = [new fixed_1.FixedInterval(position, 0)];
        return this;
    };
    SetSelectionParamsBase.prototype.setEndOfLine = function (endOfLine) {
        this.endOfLine = endOfLine;
        return this;
    };
    SetSelectionParamsBase.prototype.setKeepX = function (keepX) {
        this.keepX = keepX;
        return this;
    };
    SetSelectionParamsBase.prototype.setCorrectIntervalDueToFields = function (correctIntervalDueToFields) {
        this.correctIntervalDueToFields = correctIntervalDueToFields;
        return this;
    };
    SetSelectionParamsBase.prototype.setCorrectIntervalDueToTables = function (correctIntervalDueToTables) {
        this.correctIntervalDueToTables = correctIntervalDueToTables;
        return this;
    };
    SetSelectionParamsBase.prototype.setUseFieldUiChecks = function (useFieldUiChecks) {
        this.useFieldUiChecks = useFieldUiChecks;
        return this;
    };
    return SetSelectionParamsBase;
}());
exports.SetSelectionParamsBase = SetSelectionParamsBase;
var SetSelectionParams = (function (_super) {
    tslib_1.__extends(SetSelectionParams, _super);
    function SetSelectionParams() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SetSelectionParams.prototype, "interval", {
        get: function () { return this._intervals[0]; },
        enumerable: false,
        configurable: true
    });
    ;
    return SetSelectionParams;
}(SetSelectionParamsBase));
exports.SetSelectionParams = SetSelectionParams;
var SetSelectionParamsFull = (function (_super) {
    tslib_1.__extends(SetSelectionParamsFull, _super);
    function SetSelectionParamsFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SetSelectionParamsFull.prototype, "intervals", {
        get: function () { return this._intervals; },
        enumerable: false,
        configurable: true
    });
    return SetSelectionParamsFull;
}(SetSelectionParamsBase));
exports.SetSelectionParamsFull = SetSelectionParamsFull;
